<template>

  <div class="addToCart-section">

    <h1 class="title">{{ content.title }}</h1>

    <p class="subtitle">{{ content.subtitle }}</p>

    <p class="original-price"> &nbsp {{ content.originalPrice }} &nbsp </p>

    <div class="offers">

      <p
          v-for="(offer, index) in content.offers"
          :key="index"
      >
        {{ offer }}
      </p>

    </div>

    <h1 class="pack-content-title">{{ content.packContentTitle }}</h1>

    <ul>
      <li
          v-for="(item, index) in content.packageContent"
          :key="index"
      >
        {{ item }}
      </li>
    </ul>

    <p class="additional-info"> {{ content.additionalInfo }} </p>

    <img class="product-image" :src="content.productImg" alt="product">

    <div class="colors-wrapper">

      <span>Color</span>

      <div
          v-for="(color, index) in content.productColors"
          :key="index"
          class="option">
        <label>
          <input
              type="radio"
              v-model="chosenOption"
              :value="color"
              :checked="index === 0"
              @change="radioChangeHandler(index)"
          > {{ color }} </label>
      </div>

    </div>

    <counter @counter-change="counterChangeHandler($event)"/>

    <div class="add-button" @click="addToCartHandler">
      <i class="fas fa-shopping-cart"/>
      <span>{{ content.submitButtonLabel }}</span>
    </div>

    <span class="shipping-info">{{ content.shippingInfo }}</span>

    <img class="certifications" :src="content.certificationsImg" alt="certification">

  </div>

</template>

<script>

import {ref} from "vue";
import Counter from '@/components/Counter.vue';

export default {

  name: 'AddToCart',

  props: ['content'],

  components: {
    Counter,
  },

  setup(props, {emit}) {

    const counterValue = ref(1);

    const chosenOption = ref();

    chosenOption.value = props.content.productColors[0];

    const radioChangeHandler = (index) => {
      emit("changedRadioOption", index);
    };

    const counterChangeHandler = (value) => {
      counterValue.value = value;
    }

    const addToCartHandler = () => {
      console.log('Chosen options: ' + chosenOption.value);
      console.log('Chosen quantity: ' + counterValue.value);
    }

    return {
      radioChangeHandler,
      counterChangeHandler,
      addToCartHandler,
      counterValue,
      chosenOption,
    }

  }

}

</script>

<style lang="scss" scoped>

.addToCart-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;

  .title {
    color: rgb(136, 136, 136);
    text-align: center;
    margin-bottom: 0;
    font-size: 1.5em;
  }

  .subtitle {
    font-size: 0.8em;
  }

  .original-price {
    font-weight: 700;
    text-decoration: line-through;
    color: rgb(187, 187, 187);
  }

  .offers {
    font-weight: 700;
    color: rgb(161, 0, 0);
    background-color: rgba(155,155,155,.17);
    width: 100%;
    text-align: center;
  }

  .pack-content-title {
    align-self: flex-start;
    margin-bottom: 0;
    font-size: 1.4em;
  }

  ul {
    align-self: flex-start;
  }

  .additional-info {
    font-size: 0.6em;
    font-weight: 700;
  }

  .product-image {
    border-radius: 30px;
    border: 3px solid rgba(155,155,155,.22);
    width: 302px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  img {
    max-width: 100%;
  }

  .colors-wrapper {
    width: 100%;
    background-color: rgba(155,155,155,.1);
    padding: 10px;

    .option {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      font-size: 0.7em;
      margin-top: 20px;

      label, input[type=radio] {
        cursor: pointer;
      }
    }

  }

  .counter-wrapper {
    margin: 10px 0;
  }

  .add-button {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    cursor: pointer;
    background-color: #d0021b;
    color: #fff;
    padding: 10px;
    font-size: 19px;
    line-height: 1.5;
    font-weight: 700;
    border-radius: 20px;
    margin: 10px 0;

    span {
      font-size: 29px;
      line-height: 1;
      font-weight: 700;
      text-align: center;
      letter-spacing: -1px;
      margin-left: 10px;
    }
  }

  .shipping-info {
    font-size: 0.6em;
    font-weight: 700;
  }

  .certifications {
    max-width: 100%;
    width: 100%;
    margin-top: 15px;
  }

}

@media only screen and (max-width: 426px) {

  .addToCart-section {

    .title {
      font-size: 1.2em;
    }

    .pack-content-title {
      font-size: 1em;
    }

  }

}

</style>